import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewPhoneNumber } from '@app/core/interfaces/new-phone-number';
import { UserLevel } from '@app/core/models/user-level';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { PhoneNumber } from '@business/phone-number/models/phone-number';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TeamsPartnerNumber } from '../interfaces/teams-partner-number';

@Injectable({
  providedIn: 'root',
})
export class PhoneNumberRepository {
  constructor(
    private http: HttpClient,
    private utils: Utils
  ) {}

  add(newPhoneNumber: NewPhoneNumber): Observable<void> {
    return this.utils.apiUrl('/phoneNumbers').pipe(
      mergeMap((url) => this.http.post<void>(url, newPhoneNumber)),
      wrapError('phone-number-repository:add')
    );
  }

  delete(id: number): Observable<void> {
    return this.utils.apiUrl(`/phoneNumbers/${id}`).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('phone-number-repository:delete')
    );
  }

  list(): Observable<PhoneNumber[]> {
    return this.utils.apiUrl('/phoneNumbers').pipe(
      mergeMap((url) => this.http.get<PhoneNumber[]>(url)),
      wrapError('phone-number-repository:list')
    );
  }

  listEnterprisePhoneNumbers(): Observable<PhoneNumber[]> {
    return this.utils.routeBasedApiUrl('/phoneNumbers', UserLevel.EnterpriseAdmin).pipe(
      mergeMap((url) => this.http.get<PhoneNumber[]>(url)),
      wrapError('phone-number-repository:list-enterprise-phone-numbers')
    );
  }

  setAsMainNumber(phoneNumber: PhoneNumber): Observable<void> {
    return this.utils.apiUrl(`/phoneNumbers/${phoneNumber.id}/setAsMainNumber`).pipe(
      mergeMap((url) => this.http.put<void>(url, phoneNumber)),
      wrapError('phone-number-repository:set-as-main-number')
    );
  }

  togglePrivate(phoneNumber: PhoneNumber) {
    return this.utils.apiUrl(`/phoneNumbers/${phoneNumber.id}/setAsPrivate`).pipe(
      mergeMap((url) => this.http.put<void>(url, phoneNumber)),
      wrapError('phone-number-repository:toggle-private')
    );
  }

  update(phoneNumber: PhoneNumber): Observable<void> {
    return this.utils.apiUrl(`/phoneNumbers/${phoneNumber.id}`).pipe(
      mergeMap((url) => this.http.put<void>(url, phoneNumber)),
      wrapError('phone-number-repository:update')
    );
  }

  getTeamsPartnerNumbers(): Observable<TeamsPartnerNumber[]> {
    return this.utils.routeBasedApiUrl('/teams-partner/numbers', UserLevel.EnterpriseAdmin).pipe(
      mergeMap((url) => this.http.get<TeamsPartnerNumber[]>(url)),
      wrapError('phone-number-repository:get-teams-partner-number')
    );
  }
}
